export const newLabelCopy = {
  header: '',
  description: '',
  inputLabel: '',
  confirmBtnText: '',
  successToast: '',
};
